export const authenticationConstants = {
    ...getConstantObj()
};

function getConstantObj() {
    let obj = {
        login_request: "login_request",
        login_success: "login_success",
        login_failure: "login_failure",

        refreshAccessToken_request: "refreshAccessToken_request",
        refreshAccessToken_success: "refreshAccessToken_success",
        refreshAccessToken_failure: "refreshAccessToken_failure",
        
        generateEmailOTP_request: "generateEmailOTP_request",
        generateEmailOTP_success: "generateEmailOTP_success",
        generateEmailOTP_failure: "generateEmailOTP_failure",
        
        resetPassword_request: "resetPassword_request",
        resetPassword_success: "resetPassword_success",
        resetPassword_failure: "resetPassword_failure",
        
        logout_request: "logout_request",
        logout_success: "logout_success",
        logout_failure: "logout_failure",

        getUserInfo_request: "getUserInfo_request",
        getUserInfo_success: "getUserInfo_success",
        getUserInfo_failure: "getUserInfo_failure",

        loginModalVisiblity: "loginModalVisiblity",
    }

    let obj_formatted = {};
    let domain = "distributorPortal.authentication/";
    for (let property in obj) {
        if (obj.hasOwnProperty(property)) {
            obj_formatted[property] = domain + obj[property];
        }
    }

    return obj_formatted;
}